var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading__title-container"},_vm._l((_setup.texts),function(text){return _c(_setup.Heading,{key:text,staticClass:"loading__title",class:{
        'loading__title--active': _setup.currentText === text,
        'loading__title--entering': _setup.currentText === text && _setup.isEntering,
        'loading__title--leaving': _setup.previousText === text
      },attrs:{"level":2}},[_vm._v(" "+_vm._s(text)+" ")])}),1),_c(_setup.ProgressBar,{staticClass:"loading__progressbar",attrs:{"progress":_setup.progress,"progress-color":_setup.NebraskaColors.brandPrimary}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }